import { createClient, fetchExchange } from 'urql';
import { cache } from './cache';

export const client = createClient({
  url: '/graphql',
  exchanges: [cache, fetchExchange],
});
